import script from "./GlobalDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalDrawer.vue?vue&type=script&setup=true&lang=js"

import "./GlobalDrawer.vue?vue&type=style&index=0&id=21edca8c&lang=scss"

const __exports__ = script;

export default __exports__